export const ID_TAB_EVENT_2024 = {
    christmasTree: "christmas-tree",
    instruction: "instruction",
    navidadExplosive: "navidad-explosive",
    rankTable: "rank-table",
    congratulation: "congratulation"
}

export const ID_TAB_EVENT_2025 = {
  navidadExplosive: "navidad-explosive",
  christmasTree: "christmas-tree"
}

export const ID_TAB_EVENT_NEW_YEAR = {
  gameFireworks: "new-year-event",
  christmasTree: "christmas-tree",
  specialCode: "special-code",
  rankTable: "rank-table",
  instruction: "instruction",
  congratulation: "congratulation"
};

export const TAB_EVENT_NEW_YEAR = [
  {
    title: "Navidad Explosiva",
    id: ID_TAB_EVENT_NEW_YEAR.gameFireworks,
  },
  {
    title: "Árbol de Navidad",
    id: ID_TAB_EVENT_NEW_YEAR.christmasTree,
  },
  // {
  //   title: "Special Code",
  //   id: ID_TAB_EVENT_NEW_YEAR.specialCode,
  // },
  {
    title: "Tabla de Clasificación",
    id: ID_TAB_EVENT_NEW_YEAR.rankTable,
  },
  {
    title: "Instrucciones",
    id: ID_TAB_EVENT_NEW_YEAR.instruction,
  },
  // {
  //   title: "Congratulation",
  //   id: ID_TAB_EVENT_NEW_YEAR.congratulation,
  // },
];

export const TAB_EVENT_FINISHED_NEW_YEAR = [
  {
    title: "Tabla de Clasificación",
    id: ID_TAB_EVENT_NEW_YEAR.rankTable,
  },
  {
      title: "Congratulation",
      id: ID_TAB_EVENT_NEW_YEAR.congratulation,
  },
  {
    title: "Instrucciones",
    id: ID_TAB_EVENT_NEW_YEAR.instruction,
  },
]

export const ROUTER_EVENT_2024 = [
  { title: "Navidad Explosiva", id: ID_TAB_EVENT_2024.navidadExplosive },
  { title: "Christmas tree", id: ID_TAB_EVENT_2024.christmasTree },
  { title: "Rank Table", id: ID_TAB_EVENT_2024.rankTable },
  { title: "Congratulation", id: ID_TAB_EVENT_2024.congratulation },
  { title: "Instruction", id: ID_TAB_EVENT_2024.instruction },
];

export const ID_GIFT_EVENT_2024 = {
  gift: 0,
  superGift: 1,
};

export const ID_RANK_TABLE_EVENT_2024 = {
  rank: 0,
  myRank: 1
}
